<template>
    <b-modal ref="mdlEsecuzioneEsercizio" size="mg" no-close-on-backdrop @ok="onOk" @hidden="onHidden" centered>
        <template #modal-title> <i class="fas fa-running mr-2"></i> <span style="font-size: 1.3rem">Esecuzione Esercizio</span> </template>

        <div class="sa-flexbox-pianificazione-modal p-4">
            <!-- Box Elegante con i dati previsti -->
            <div class="mb-5 p-4 border rounded shadow-sm bg-white">
                <h3 class="font-weight-bold text-primary mb-4 pb-2 border-bottom"><i class="fas fa-dumbbell mr-2"></i> {{ jsonData.nomeEsercizio || "Esercizio" }}</h3>

                <b-row class="text-center">
                    <b-col cols="4">
                        <div class="sa-label-data">Serie Previste</div>
                        <div class="h3 font-weight-bold text-dark mt-2">{{ jsonData.seriePreviste || "-" }}</div>
                    </b-col>
                    <b-col cols="4" class="border-left border-right">
                        <div class="sa-label-data">Rip. Previste</div>
                        <div class="h3 font-weight-bold text-dark mt-2">{{ jsonData.ripetizioniPreviste || "-" }}</div>
                    </b-col>
                    <b-col cols="4">
                        <div class="sa-label-data">Riposo</div>
                        <div class="h3 font-weight-bold text-dark mt-2">{{ jsonData.riposoPrevisto || "-" }}</div>
                    </b-col>
                </b-row>
            </div>

            <!-- Box per l'inserimento dell'esecuzione -->
            <div class="p-4 border rounded shadow-sm bg-light">
                <h4 class="font-weight-bold mb-4 text-success"><i class="fas fa-check-circle mr-2"></i> Registra Dati Esecuzione</h4>

                <b-row>
                    <b-col cols="12" sm="6">
                        <b-form-group label="Serie Eseguite:" label-class="sa-label-input font-weight-bold text-muted">
                            <b-form-input v-model="jsonData.serieEseguite" type="number" min="0" placeholder="Es. 3" size="lg"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6">
                        <b-form-group label="Ripetizioni Eseguite:" label-class="sa-label-input font-weight-bold text-muted">
                            <b-form-input v-model="jsonData.ripetizioniEseguite" type="number" min="0" placeholder="Es. 10" size="lg"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-form-group label="Note:" label-class="sa-label-input font-weight-bold text-muted mt-3" class="mb-0">
                    <b-form-textarea v-model="jsonData.noteEsecuzione" rows="4" size="lg"></b-form-textarea>
                </b-form-group>
            </div>
        </div>

        <template #modal-footer="{ ok, cancel }">
            <b-button size="lg" variant="secondary" @click="cancel()" class="px-4">Annulla</b-button>
            <b-button size="lg" variant="success" @click="ok()" class="px-4">Salva Esecuzione</b-button>
        </template>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../../../utility/UtilityMixin";

export default {
    name: "AfaPrescrizioneEsercizioEsecuzioneModalComponent",
    mixins: [UtilityMixin],
    data() {
        return {
            jsonData: this.getEmptyData(),
            pathresourceEsecuzione: "/pazientemedicinadellosportprescrizioneesercizioesecuz",
        };
    },
    methods: {
        show(esercizio) {
            if (!esercizio || !esercizio.id) {
                this.$bvToast.toast("Impossibile aprire l'esecuzione. Dati esercizio mancanti.", { title: "Errore", variant: "danger" });
                return;
            }
            this.jsonData = {
                idPrescrizioneDettaglio: esercizio.id,
                nomeEsercizio: esercizio.prescrizione || esercizio.nome || esercizio.titolo,
                seriePreviste: esercizio.serie,
                ripetizioniPreviste: esercizio.ripetizioni,
                riposoPrevisto: esercizio.riposo,

                serieEseguite: esercizio.serie || null,
                ripetizioniEseguite: esercizio.ripetizioni || null,
                noteEsecuzione: null,
            };
            this.$refs.mdlEsecuzioneEsercizio.show();
        },

        getEmptyData() {
            return {
                idPrescrizioneDettaglio: null,
                nomeEsercizio: null,
                seriePreviste: null,
                ripetizioniPreviste: null,
                riposoPrevisto: null,
                serieEseguite: null,
                ripetizioniEseguite: null,
                noteEsecuzione: null,
                dataEsecuzione: null,
            };
        },

        onOk(bvModalEvent) {
            bvModalEvent.preventDefault();
            if (!this.jsonData.serieEseguite || !this.jsonData.ripetizioniEseguite) {
                this.$bvToast.toast("Inserisci i valori per le serie e le ripetizioni eseguite.", {
                    title: "Campi Obbligatori",
                    autoHideDelay: 4000,
                    variant: "warning",
                });
                return;
            }

            let dataDaSalvare = this.preparaDatiPerSalvataggio();
            this.saveResource(this.pathresourceEsecuzione, dataDaSalvare, this.saveResourceSuccess, null);
        },

        preparaDatiPerSalvataggio() {
            let serieEseguite = Number(this.jsonData.serieEseguite);
            let ripetizioniEseguite = Number(this.jsonData.ripetizioniEseguite);
            let seriePreviste = Number(this.jsonData.seriePreviste);
            let ripetizioniPreviste = Number(this.jsonData.ripetizioniPreviste);
            let haCompletatoTutto = serieEseguite >= seriePreviste && ripetizioniEseguite >= ripetizioniPreviste ? "SI" : "NO";
            return {
                idPrescrizioneDettaglio: this.jsonData.idPrescrizioneDettaglio,
                serieEseguite: serieEseguite,
                ripetizioniEseguite: ripetizioniEseguite,
                note: this.jsonData.noteEsecuzione,
                completato: haCompletatoTutto,
            };
        },

        saveResourceSuccess() {
            this.$bvToast.toast("Esecuzione registrata con successo.", {
                title: "Operazione Completata",
                variant: "success",
                solid: true,
            });
            this.$refs.mdlEsecuzioneEsercizio.hide();
        },

        onHidden() {
            this.jsonData = this.getEmptyData();
            this.$emit("afterSave");
        },
    },
};
</script>

<style scoped>
.sa-flexbox-pianificazione-modal {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* Stile per le label informative (Serie, Ripetizioni, Riposo) */
.sa-label-data {
    font-size: 1.1rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;
}

/* Stile per le label degli input */
.sa-label-input {
    font-size: 1.15rem !important;
    margin-bottom: 8px;
}

/* Forza un font leggermente più grande e comodo nei campi input stessi */
.form-control-lg {
    font-size: 1.25rem;
}
</style>
